import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { MatDialogRef } from "@angular/material/dialog";
import { take } from "rxjs/operators";
import { OnboardingService } from "src/app/shared/services/onboarding/onboarding.service";

@Component({
  selector: "vpn-connection-modal",
  templateUrl: "./vpn-connection-modal.component.html",
  styleUrls: ["../warning-modal/warning-modal.component.scss"],
})
export class VpnConnectionModalComponent {
  text: string = "GLOBAL.MESSAGES.VPN_CONNECTION_REMIND";

  constructor(
    private router: Router,
    private onboardingService: OnboardingService,
    public dialogRef: MatDialogRef<VpnConnectionModalComponent>,
  ) {}

  dismiss(): void {
    this.dialogRef.close();
  }

  help(): void {
    this.onboardingService
      .getOnboarding()
      .pipe(take(1))
      .subscribe((onboarding) => {
        const vpnTopic = onboarding.topics.find(
          (topic) => topic.name.toUpperCase().includes("VPN"),
        );

        this.router.navigate(
          [`/${this.isTeacher ? "teacher" : "student"}/courses/onboarding/`],
          {
            queryParams: vpnTopic ? { topicId: vpnTopic.id } : undefined,
          },
        );

        this.dismiss();
      });
  }

  get isTeacher(): boolean {
    return this.router.url.includes("teacher");
  }
}
